import { Component } from '@theme/component';

/**
 * @typedef {Object} HeaderComponentRefs
 * @property {HTMLElement} headerMenu - The header menu element
 */

/**
 * A custom element that manages the site header.
 *
 * @extends {Component<HeaderComponentRefs>}
 */
class HeaderComponent extends Component {
  /**
   * Width of window when header drawer was hidden
   * @type {number | null}
   */
  #menuDrawerHiddenWidth = null;

  /**
   * Handles the overflow minimum event from the header menu
   * @param {CustomEvent<{ minimumReached: boolean }>} event
   */
  #handleOverflowMinimum = (event) => {
    this.#updateMenuVisibility(event.detail.minimumReached);
  };

  /**
   * Updates the visibility of the menu and drawer
   * @param {boolean} hideMenu - Whether to hide the menu and show the drawer
   */
  #updateMenuVisibility(hideMenu) {
    const headerMenu = this.refs.headerMenu;
    const headerDrawerContainer = this.querySelector('[ref="headerDrawerContainer"]');

    if (!headerMenu || !headerDrawerContainer) return;

    if (hideMenu) {
      headerDrawerContainer.classList.remove('desktop:hidden');
      this.#menuDrawerHiddenWidth = window.innerWidth;
      headerMenu.classList.add('hidden');
    } else {
      headerDrawerContainer.classList.add('desktop:hidden');
      this.#menuDrawerHiddenWidth = null;
      headerMenu.classList.remove('hidden');
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('overflowMinimum', this.#handleOverflowMinimum);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('overflowMinimum', this.#handleOverflowMinimum);
  }
}

if (!customElements.get('header-component')) {
  customElements.define('header-component', HeaderComponent);
}
